<template>
  <div class="common-header" :style="{ backgroundColor: backgroundColor }">
    <!-- 返回按钮 -->
    <div class="header-left" @click="goBack">
      <van-icon name="arrow-left" size="20" />
    </div>

    <!-- 页面标题（可选） -->
    <div v-if="showTitle" class="header-title">
      {{ title }}
    </div>

    <!-- 右侧占位（可扩展） -->
    <div class="header-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";

export default {
  name: "CommonHeader",
  components: {
    [Icon.name]: Icon,
  },
  props: {
    // 页面标题文本
    title: {
      type: String,
      default: "",
    },
    // 是否显示标题
    showTitle: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: "#ffffff",
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1); // 返回上一页
      this.$emit("back")
      // 或者：this.$router.back();
    },
  },
};
</script>

<style scoped>
.common-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  z-index: 999;
  position: fixed;
  width: 100%;
  box-sizing: border-box;
}

.header-left {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.header-title {
  /* position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  max-width: 60%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis; */
}

.header-right {
 
}
</style>
